module.exports = __webpack_public_path__ + "static/img/vip11.2495d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/vipMember/img/vip11.png
// module id = 92GW
// module chunks = 25